import { intersection, Inclusion } from '@thalesrc/js-utils/array/intersection';

declare global {
  export interface Set<T> {
    /**
     * #### Intersection
     *
     * Gets the intersection of the two arrays or sets
     *
     * * * *
     * Example:
     * ```typescript
     * import "@thalesrc/js-utils/set/proto/intersection";
     *
     * const base = new Set(["a", "b", "c", "d"]);
     *
     * base.getIntersection(["a", "b"]); // Set(["a", "b"])
     * ```
     * * * *
     * @param base Base Set
     * @param inclusion Set or Array to include its values
     * @param allEquals By default all the same items encountered in the inclusion will be included, set this argument as false to get real intersection
     * @returns Intersection of base and inclusion
     */
    getIntersection(inclusion: Inclusion, allEquals?: boolean): Set<T>;
  }
}

Set.prototype.getIntersection = function<T>(this: Set<T>, inclusion: Inclusion, allEquals = true) {
  return intersection(this, inclusion, allEquals);
};
